<template>
  <div class="widget-collapces">
    <SlimCategoryCard
      v-for="item in widgets"
      :key="item.title"
      class="widget-collapces__item"
      :title="item.title"
      :desc="item.desc"
      :to="item.to"
      :src="item.src"
      :games="item.games"
      :remainder="item.remainder"
    />
  </div>
</template>

<script>
import SlimCategoryCard from '@/components/shared/Cards/SlimCategoryCard'

export default {
  name: 'WidgetCollapces',
  components: {
    SlimCategoryCard,
  },
  props: {
    widgets: { type: Array },
  },
}
</script>
<style lang="scss" src="./style.scss" scoped></style>
